module.exports = __webpack_public_path__ + "img/Render(1).34f4db71.png";